// ================================================================================
// Cornerstone only pauses autoplay on hover, which keyboard, screen reader and
// touch users never trigger. Pause on focus or touch, and never start under
// prefers-reduced-motion. Pausing is one-way on purpose: a carousel that starts
// moving again under someone interacting with it is the thing being avoided.
// ================================================================================

const SELECTOR = '[data-autoplay="true"][data-id]';
const PAUSE_BUTTON = ".slideshow-navigation__pause-button";

function prefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

// Pausing from here does not update the slideshow's pause button; mirror its label.
function syncPauseButton(slider) {
  const container = slider.dataset.navigationContainer
    ? slider.closest(slider.dataset.navigationContainer)
    : slider;
  const button = container && container.querySelector(PAUSE_BUTTON);

  if (!button || button.dataset.isPlaying !== "true") return;

  button.dataset.isPlaying = "false";
  button.setAttribute("aria-label", button.dataset.playLabel);
}

function pause(slider) {
  document.dispatchEvent(new CustomEvent(`scroll-slider-${slider.dataset.id}:pause`));
  syncPauseButton(slider);
}

function watch(slider) {
  if (slider.dataset.a11yAutoplayBound === "true") return;
  slider.dataset.a11yAutoplayBound = "true";

  const stop = () => pause(slider);

  slider.addEventListener("focusin", stop, { once: true });
  slider.addEventListener("touchstart", stop, { once: true, passive: true });

  if (!prefersReducedMotion()) return;

  // The component only starts listening for the pause event once it upgrades,
  // which can happen before or after this script runs. Cover both: pause now,
  // and again when the component reports that it has initialized.
  stop();
  document.addEventListener(`scroll-slider-${slider.dataset.id}:initialized`, stop, { once: true });
}

function init(root) {
  (root || document).querySelectorAll(SELECTOR).forEach(watch);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => init(), { once: true });
} else {
  init();
}

document.addEventListener("shopify:section:load", (evt) => init(evt.target));
